import { render, staticRenderFns } from "./AutoPostBoostingHeader.vue?vue&type=template&id=6df5d6bf&scoped=true&"
import script from "./AutoPostBoostingHeader.vue?vue&type=script&lang=ts&"
export * from "./AutoPostBoostingHeader.vue?vue&type=script&lang=ts&"
import style0 from "./AutoPostBoostingHeader.vue?vue&type=style&index=0&id=6df5d6bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df5d6bf",
  null
  
)

export default component.exports